import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="navbar">
        <div className="logo">
          <span className="logo-icon">C</span>
          <span className="logo-text">CNCCAR</span>
        </div>
        <nav className="nav">
          <ul className="nav-list">
            <li className="nav-item"><a href="#reservations">Reservations</a></li>
            <li className="nav-item"><a href="#vehicles">Vehicles</a></li>
            <li className="nav-item"><a href="#locations">Locations</a></li>
            <li className="nav-item"><a href="#car-sales">Car Sales</a></li>
            <li className="nav-item"><a href="#for-business">For Business</a></li>
          </ul>
        </nav>
        <div className="contact-us">
          <button className="contact-btn">Contact Us</button>
        </div>
      </div>
    </header>
  );
};

export default Header; 